// extracted by mini-css-extract-plugin
export default {"heading":"Targeting_heading__NxUoC","wrapper":"Targeting_wrapper__wEbut"};